const MESSAGE_EDIT_WINDOW_MS = 24 * 60 * 60 * 1000;

export function canEditMessage(timestamp: number | string | undefined, now = Date.now()): boolean {
  if (timestamp == null || timestamp === '') return false;
  const numeric = Number(timestamp);
  const createdAt = Number.isFinite(numeric) ? numeric : Date.parse(String(timestamp));
  const age = now - createdAt;
  return Number.isFinite(age) && age >= 0 && age < MESSAGE_EDIT_WINDOW_MS;
}
